import { isTourV1Item } from 'lib/checkout/checkoutUtils'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'
import { createSelector } from 'reselect'

export const getTourV1Items = createSelector(
  (state: App.State) => state.checkout.cart.items,
  items => items.filter(isTourV1Item),
  reselectShallowEqual,
)
